import React from "react";
import { FieldProps } from "@rjsf/utils";
import PortfolioMultiSelect from "@/components/Inputs/RJSFInputs/PortfolioMultiSelect/PortfolioMultiSelect";
import { IPortfolioMetadata } from "@pulse-ui/codegen/generated_ts/org_metadata";

interface IPortfolioMultiSelectProps {
  portfolios: string[];
  org_metadata: { portfolios: IPortfolioMetadata[] };
  rootFormData?: any;
}

const withAdditionalProps = (
  Component: React.ComponentType<FieldProps & IPortfolioMultiSelectProps>,
  additionalProps: IPortfolioMultiSelectProps
) => {
  return (props: FieldProps) => <Component {...props} {...additionalProps} />;
};

const PortfolioMultiSelectWithProps = (
  portfolios: string[],
  org_metadata: { portfolios: IPortfolioMetadata[] },
  rootFormData?: any
) =>
  withAdditionalProps(PortfolioMultiSelect, {
    portfolios,
    org_metadata,
    rootFormData,
  });

export default PortfolioMultiSelectWithProps;
